import { withSearchResult } from 'hocs/search';
import { TrashedDocumentList } from './trashed-document-list';

export const TrashedDocumentListWithSearchResult = withSearchResult(TrashedDocumentList);
